import { useColors } from "../../../hooks/colors/useColors";
import { Grid, Text } from "@mantine/core";
import { MyCard } from "../../UI/my-card/MyCard";
import { MyH1 } from "../../UI/my-h1/MyH1";
import { MyButton } from "../../UI/my-button/MyButton";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { IconArrowNarrowRight } from "@tabler/icons";
import {
  SpecialistData,
  useSpecialistList,
} from "../../../hooks/react-query/useSpecialistList";
import { Fragment } from "react";

interface SpecialistCategory {
  category: string;
  specialists: SpecialistData[];
}

export function PricingList() {
  const { colors } = useColors();
  const router = useRouter();
  const { t } = useTranslation("common");
  const { specialists, move } = useSpecialistList();

  function specialistCategories(): SpecialistCategory[] {
    const specialistGroupLinks: SpecialistCategory[] = [];
    const specialistCategories: string[] = [];
    if (specialists) {
      Object.keys(specialists).map((slug) => {
        const specialist: SpecialistData = specialists[slug];
        if (!specialistCategories.includes(specialist.category))
          specialistCategories.push(specialist.category);
      });

      specialistCategories
        .sort(function (a, b) {
          return a.toString().localeCompare(b.toString());
        })
        .forEach((category) => {
          specialistGroupLinks.push({
            category: category,
            specialists: [],
          });
        });

      specialistGroupLinks.map((cat) => {
        Object.keys(specialists).map((slug) => {
          const specialist: SpecialistData = specialists[slug];

          if (specialist.category === cat.category) {
            cat.specialists.push(specialist);
          }
        });
      });
    }

    return specialistGroupLinks;
  }

  function sortMap(categoryMap: SpecialistCategory[]): SpecialistCategory[] {
    //assign categories in desired order: ex. pedopsychiatry first
    const reorderedLinks1 = move(3, 1, categoryMap);
    const reorderedLinks2 = move(4, 2, reorderedLinks1);
    return move(5, 3, reorderedLinks2);
  }

  async function goToSpecialist() {
    await router.push("/agendar");
  }

  return (
    <div className="w-full m-0">
      {specialists && specialistCategories() && (
        <Fragment>
          {sortMap(specialistCategories()).map((category, index) => {
            return (
              <div key={index}>
                <MyH1 centerText>{category.category}</MyH1>
                <Grid>
                  {category.specialists.map((specialist, specialistIndex) => {
                    if (specialist.services) {
                      return (
                        <Grid.Col
                          key={specialistIndex}
                          span={{ base: 12, md: 6, lg: 4 }}
                        >
                          <MyCard withBorder>
                            <div className="p-2 flex flex-col justify-between h-full">
                              <div className="py-4">
                                <MyH1
                                  centerText
                                  color={colors.secondary}
                                  size={26}
                                >
                                  {specialist.name}
                                </MyH1>
                              </div>
                              <div>
                                {specialist.services.map(
                                  (service, serviceIndex) => {
                                    return (
                                      <Text
                                        className="ml-4"
                                        size="lg"
                                        key={serviceIndex}
                                      >
                                        {service.description}
                                        <b className="ml-2">{`${service.price}€`}</b>
                                      </Text>
                                    );
                                  }
                                )}
                              </div>
                              <div className="flex justify-center flex-col items-center py-6 gap-4">
                                <MyButton
                                  onClick={() => goToSpecialist()}
                                  title={t("book-app")}
                                  color={colors.secondary}
                                  rounded
                                  rightIcon={<IconArrowNarrowRight />}
                                />
                              </div>
                            </div>
                          </MyCard>
                        </Grid.Col>
                      );
                    } else {
                      return null;
                    }
                  })}
                </Grid>
              </div>
            );
          })}
        </Fragment>
      )}
    </div>
  );
}
